import { style, styleVariants } from '@vanilla-extract/css';
import { NotificationVariant } from '../../store/notification.types';
import { nToPx, themeVars } from '@tundr/theme';

export const notificationWrapperClass = style({
  display: 'flex',
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 10000,
  width: '100%',
  gap: themeVars.space.x4,
  padding: nToPx(themeVars.space.x3, themeVars.space.x4),
  fontSize: themeVars.font.size.textMd,
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottomWidth: 2,
  borderBottomStyle: 'solid',
});

export const notificationDismissableClass = style({
  paddingRight: themeVars.space.x12,
});

export const dismissIconClass = style({
  position: 'absolute',
  top: themeVars.space.x3,
  right: themeVars.space.x3,
  fontSize: themeVars.font.size.textLg,
});

export const notificationBackgroundByVariantClass = styleVariants({
  [NotificationVariant.INFO]: {
    color:
      themeVars.colors.components.toast[NotificationVariant.INFO].text.default,
    borderColor:
      themeVars.colors.components.toast[NotificationVariant.INFO].border,
    backgroundColor:
      themeVars.colors.components.toast[NotificationVariant.INFO].background
        .default,
  },
  [NotificationVariant.WARNING]: {
    color:
      themeVars.colors.components.toast[NotificationVariant.WARNING].text
        .default,
    borderColor:
      themeVars.colors.components.toast[NotificationVariant.WARNING].border,
    backgroundColor:
      themeVars.colors.components.toast[NotificationVariant.WARNING].background
        .default,
  },
  [NotificationVariant.SUCCESS]: {
    color:
      themeVars.colors.components.toast[NotificationVariant.SUCCESS].text
        .default,
    borderColor:
      themeVars.colors.components.toast[NotificationVariant.SUCCESS].border,
    backgroundColor:
      themeVars.colors.components.toast[NotificationVariant.SUCCESS].background
        .default,
  },
  [NotificationVariant.ERROR]: {
    color:
      themeVars.colors.components.toast[NotificationVariant.ERROR].text.default,
    borderColor:
      themeVars.colors.components.toast[NotificationVariant.ERROR].border,
    backgroundColor:
      themeVars.colors.components.toast[NotificationVariant.ERROR].background
        .default,
    fontWeight: themeVars.font.weight.regular,
  },
});

export const statusIconWrapperClass = style({
  minWidth: 45,
  height: 45,
  borderRadius: themeVars.radius.circle,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: themeVars.colors.neutrals.white,
});

export const statusIconBackgroundClass = styleVariants({
  [NotificationVariant.INFO]: {
    backgroundColor:
      themeVars.colors.components.toast[NotificationVariant.INFO].background
        .icon,
  },
  [NotificationVariant.WARNING]: {
    backgroundColor:
      themeVars.colors.components.toast[NotificationVariant.WARNING].background
        .icon,
  },
  [NotificationVariant.SUCCESS]: {
    backgroundColor:
      themeVars.colors.components.toast[NotificationVariant.SUCCESS].background
        .icon,
  },
  [NotificationVariant.ERROR]: {
    backgroundColor:
      themeVars.colors.components.toast[NotificationVariant.ERROR].background
        .icon,
  },
});

export const notificationIconClass = style({
  fontSize: themeVars.font.size.iconMd,
  position: 'relative',
  top: -1,
});

export const notificationLeftSideClass = style({
  display: 'flex',
  alignItems: 'center',
  gap: themeVars.space.x5,
});

export const notificationContentClass = style({
  display: 'flex',
  flexDirection: 'column',
  gap: themeVars.space.x1,
  width: '100%',
});
